import { useEffect, useMemo, useState } from 'react';
import { getBackendUrl } from '../lib/apiUrls';
import { createFamilyClient } from '../lib/familyClient';

export function useFamilyPresence(currentUser) {
  const familyClient = useMemo(() => createFamilyClient(getBackendUrl()), []);
  const [family, setFamily] = useState(null);

  useEffect(() => {
    let isMounted = true;

    async function loadFamily() {
      if (!currentUser?.userId) {
        setFamily(null);
        return;
      }

      try {
        const response = await familyClient.getFamily(currentUser.userId);
        const resolvedFamily = response?.family || response?.data?.family || response || null;

        if (isMounted) {
          setFamily(resolvedFamily?._id || resolvedFamily?.id ? resolvedFamily : null);
        }
      } catch {
        if (isMounted) {
          setFamily(null);
        }
      }
    }

    void loadFamily();

    return () => {
      isMounted = false;
    };
  }, [currentUser?.userId, familyClient]);

  return {
    family,
    hasFamily: Boolean(family?._id || family?.id),
  };
}

export default useFamilyPresence;
